import { render, staticRenderFns } from "./image.vue?vue&type=template&id=f3d2e712&scoped=true"
import script from "./image.vue?vue&type=script&lang=js"
export * from "./image.vue?vue&type=script&lang=js"
import style0 from "./image.vue?vue&type=style&index=0&id=f3d2e712&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d2e712",
  null
  
)

export default component.exports